import React from 'react'
// libs
import { useDispatch, useSelector } from 'react-redux'
import { change, formValueSelector } from 'redux-form'
// components
import { ReduxSelect } from 'components/FormElements'
// constants
import { Forms } from 'constants/forms'
import { FieldType } from 'types/graphql'
// store
import { objectEntitiesSelector } from 'store/reducers/objectEntities'
// context
import { RiskTemplateAPIContext } from 'containers/Risks/RiskTemplate/Edit/layers/API'
// views
import { SetFieldWrapper } from './views'
// utils
import { required } from 'utils/validators'
import { getFieldsList } from 'utils/fields'
import { parseGraphQLErrorMessages } from 'utils/errors/parsers'
import {
  getFieldNameOptions,
  getFieldValueField,
  getRTEntityOrFieldOptions,
  getRTFieldValueField
} from 'utils/systemProcess'

interface Props {
  field: string
}

const selector = formValueSelector(Forms.SYSTEM_PROCESS_CREATE_FORM)

const SetField: React.FC<Props> = ({ field }) => {
  const dispatch = useDispatch()

  const { isRiskTemplate, riskTemplate } = React.useContext(RiskTemplateAPIContext)

  const [entityFields, setEntityFields] = React.useState([])

  const object = useSelector((state) => selector(state, 'object'))
  const property = useSelector((state) => selector(state, `${field}.fieldName`))
  const objectEntities = useSelector(objectEntitiesSelector)

  const onChange = () => dispatch(change(Forms.SYSTEM_PROCESS_CREATE_FORM, `${field}.fieldValue`, null))

  const getEntityFields = async () => {
    try {
      const fields = object ? getFieldsList(objectEntities, object.label) : null

      const options = isRiskTemplate
        ? getRTEntityOrFieldOptions(riskTemplate, true).filter((item) =>
            [FieldType.PickList, FieldType.Lookup, FieldType.Date].includes(item.fieldType)
          )
        : getFieldNameOptions(fields)

      setEntityFields(options)
    } catch (e) {
      console.log('[useTransaction.getEntityFields]: ', parseGraphQLErrorMessages(e))
    }
  }

  React.useEffect(() => {
    getEntityFields()
  }, [])

  return (
    <SetFieldWrapper>
      <ReduxSelect
        label='Property'
        validate={required}
        options={entityFields}
        menuPortalTarget={null}
        onSelectChange={onChange}
        name={`${field}.fieldName`}
      />
      {isRiskTemplate ? getRTFieldValueField(property, field) : getFieldValueField(property, field)}
    </SetFieldWrapper>
  )
}

export default SetField
